import { useState } from"react";
import { Copy, Check } from"lucide-react";

// Formate un nombre en chaîne (virgule décimale française, 2 décimales)
const fmt = (n) => Number(n || 0).toFixed(2).replace(".",",");

// Formats d'export typiques des logiciels comptables français
const FORMATS = {
 sage: {
 label:"SAGE",
 sub:"CSV Sage 100/50",
 build: (lignes, titre) =>"Compte;Libelle;Debit;Credit\n" +
 lignes
 .map((l) => `${l.c};${(l.l || titre).replace(/;/g,"")};${fmt(l.d)};${fmt(l.k)}`)
 .join("\n"),
 },
 ebp: {
 label:"EBP",
 sub:"CSV EBP Compta",
 build: (lignes, titre) => {
 const date = new Date()
 .toLocaleDateString("fr-FR")
 .split("/")
 .join("/");
 return ("Date;Compte;Libelle;Debit;Credit\n" +
 lignes
 .map((l) => `${date};${l.c};${(l.l || titre).replace(/;/g,"")};${fmt(l.d)};${fmt(l.k)}`)
 .join("\n")
 );
 },
 },
 cegid: {
 label:"Cegid",
 sub:"TSV Cegid / Excel",
 // TSV (tab-separated) : se colle directement dans Excel ou les imports Cegid Loop
 build: (lignes, titre) =>"Compte\tLibellé\tDébit\tCrédit\n" +
 lignes
 .map((l) => `${l.c}\t${l.l || titre}\t${fmt(l.d)}\t${fmt(l.k)}`)
 .join("\n"),
 },
};

export default function CopyEcritureButton({ lignes, titre ="" }) {
 const [copied, setCopied] = useState(null);

 if (!Array.isArray(lignes) || lignes.length === 0) return null;

 const copy = async (key) => {
 const content = FORMATS[key].build(lignes, titre);
 try {
 await navigator.clipboard.writeText(content);
 setCopied(key);
 setTimeout(() => setCopied(null), 1800);
 } catch {
 // Fallback : sélection / textarea temporaire
 const ta = document.createElement("textarea");
 ta.value = content;
 document.body.appendChild(ta);
 ta.select();
 try { document.execCommand("copy"); setCopied(key); setTimeout(() => setCopied(null), 1800); }
 catch (e) { console.warn("CopyEcritureButton: execCommand copy failed", e); }
 document.body.removeChild(ta);
 }
 };

 return (
 <div data-testid="copy-ecriture-toolbar" className="mt-3 flex flex-wrap items-center gap-2 no-print">
 <span className="text-[10px] font-bold uppercase tracking-wider text-slate-500 mr-1">
 Copier vers :
 </span>
 {Object.entries(FORMATS).map(([key, f]) => {
 const ok = copied === key;
 return (
 <button
 key={key}
 data-testid={`copy-ecriture-${key}`}
 onClick={() => copy(key)}
 title={f.sub}
 className={`inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-lg border transition ${
 ok
 ?"bg-emerald-50 border-emerald-300 text-emerald-700"
 :"bg-white border-keyto text-[#15294F] hover:border-[#2D6BE0]/40 hover:bg-slate-50"
 }`}
 >
 {ok ? <Check size={12} /> : <Copy size={12} />}
 {ok ?"Copié !" : f.label}
 </button>
 );
 })}
 </div>
 );
}
